export default __webpack_public_path__ + "static/media/Background_00195.dd8fdc70.png";